import React, { FC } from 'react';
import {
  default as MuiPopper,
  PopperProps as MuiPopperProps,
  PopperPlacementType as MuiPopperPlacementType
} from '@material-ui/core/Popper';
import { Uds } from '../../types';

export type PopperProps = Uds<MuiPopperProps & {}>;

export type PopperPlacementType = MuiPopperPlacementType;

export const Popper: FC<React.PropsWithChildren<PopperProps>> = ({ dataTest, ...props }) => (
  <MuiPopper data-test={dataTest} {...props} />
);
